//svg taken from the following resource
//https://reactsvgicons.com/search?q=weather
import { NavLink, useNavigate } from "react-router-dom";
import styles from "./Navigation.module.css";
import { tempToColor } from "../utils/helpers";
function Navigation({ tempColor }) {
  //the children prop will be either a login/signup component or a logout component
  const navigate = useNavigate();
  return (
    <div
      style={{
        transition: ".5s",
        backgroundColor: `${tempToColor(tempColor)}`,
      }}
      className={styles["navigation-container"]}
    >
      <div
        onClick={() => navigate("/")}
        className={styles["heading-container"]}
      >
        <div className={styles["svg-container"]}>
          <svg
            className={styles["svg-icon"]}
            viewBox="0 0 24 24"
            fill="currentColor"
            height="1em"
            width="1em"
          >
            <path d="M12.74 5.47c2.36 1.03 3.61 3.56 3.18 5.99A6.002 6.002 0 0118 16v.17a3 3 0 011-.17 3 3 0 013 3 3 3 0 01-3 3H6a4 4 0 01-4-4 4 4 0 014-4h.27C5 12.45 4.6 10.24 5.5 8.26a5.49 5.49 0 017.24-2.79m-.81 1.83c-1.77-.8-3.84.01-4.62 1.77-.46 1.02-.38 2.15.1 3.06A5.988 5.988 0 0112 10c.7 0 1.38.12 2 .34a3.506 3.506 0 00-2.07-3.04m1.62-3.66c-.55-.24-1.1-.41-1.67-.52l2.49-1.3.9 2.89a7.67 7.67 0 00-1.72-1.07m-7.46.8c-.49.35-.92.75-1.29 1.19l.11-2.81 2.96.68c-.62.21-1.22.53-1.78.94M18 9.71c-.09-.59-.22-1.16-.41-1.71l2.38 1.5-2.05 2.23c.11-.65.13-1.33.08-2.02M3.04 11.3c.07.6.2 1.17.39 1.7l-2.37-1.5L3.1 9.28c-.1.65-.13 1.33-.06 2.02M19 18h-3v-2a4 4 0 00-4-4 4 4 0 00-4 4H6a2 2 0 00-2 2 2 2 0 002 2h13a1 1 0 001-1 1 1 0 00-1-1z" />
          </svg>
        </div>
        <h3 className={styles["heading-text"]}>Live-Weather-Map</h3>
      </div>

      <nav>
        <ul className={styles["features-list"]}>
          <li>
            <NavLink className={styles["navigation-link"]} to="/">
              Home
            </NavLink>
          </li>
          <li>
            <NavLink className={styles["navigation-link"]} to="/dashboard">
              Dashboard
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default Navigation;
